import { PomodoroService } from "features/widget-workspace/service/PomodoroService";
import React from "react";
import { DefaultPomodoroWidgetSettingsEntity } from "@lifeat/shared/data-models/widget/Pomodoro/PomodoroWidgetSettingsEntity";
import { DEFAULT_ALARM_OBJ } from "@lifeat/shared/widget/PomodoroTimerConstants";
import Pomodoro from "./Pomodoro";
import { PAUSE_TIMER_LABEL } from "./TimerWidgetConstants";
import { usePomodoroSettingsInput } from "./hooks/usePomodoroSettingsInput";

interface SkeletonPomodoroProps {
    hidden: boolean;
}
export default function SkeletonPomodoro(props: SkeletonPomodoroProps) {
    const pomodoroService: PomodoroService = {
        fetchSettings: async () => DefaultPomodoroWidgetSettingsEntity(),
    };
    const { pomodoroSettingsInput, dispatchPomodoroSettingsInput } = usePomodoroSettingsInput(pomodoroService);
    return (
        <Pomodoro
            hidden={props.hidden}
            stopTimerActionButtonLabel={PAUSE_TIMER_LABEL}
            canEditSettings={false}
            isRunning={false}
            alarmSoundOptions={DEFAULT_ALARM_OBJ}
            pomodoroService={pomodoroService}
            pomodoroSettingsInput={pomodoroSettingsInput}
            dispatchPomodoroSettingsInput={dispatchPomodoroSettingsInput}
            timerAudioRef={null}
            timerVolume={0}
            setTimerVolume={() => {}}
            allowAutotransitionToggle={false}
        />
    );
}
